import React, { useState } from 'react';
import styled from 'styled-components'
import { useLocation } from 'react-router-dom';
import AdminBigMenu from './AdminBigMenu';
import AdminLnbLogoUsername from './AdminLeftLogoUsername';
import {
  HamburgerIconBtnWrapper,
  LnbSection,
  LnbToggleArea,
  LnbTopWrapper,
} from '../../component/floatingIsland/LeftNavBar';
import hamburger128 from '../../asset/gnb/hamburger_128.png';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';


export interface NavItem {
  path: string;
  label: string;
  isVisible: boolean;
}

const AdminLeftNavBar: React.FC = () => {
  const { pathname } = useLocation();
  const [isHovered, setIsHovered] = useState(false);

  const isAdminPage = () => {
    return pathname.includes('/admin');
  }

  const isVisible = isAdminPage();

  if (!isVisible) return null;

  const navItems: NavItem[] = [
    { path: `/admin/system-alert`, label: 'System-alert', isVisible: true },
    { path: `/admin/members`, label: 'Members', isVisible: true },
    { path: `/admin/venues`, label: 'Venue', isVisible: true },
    { path: `/admin/supports`, label: 'Supports', isVisible: true },
    { path: `/admin/material-aliases`, label: 'Material aliases', isVisible: true },
  ];

  const openMenuWithHover = () => {
    setIsHovered(true);
  };

  return (
    <>
      <LnbSection
        $isHovered={isHovered}
        $isVisible={isVisible}
        onMouseLeave={() => setIsHovered(false)}
      >
        <LnbTopWrapper>
          <AdminLnbLogoUsername isHovered={isHovered} />
          <LnbMenuContainer $isActive={isVisible}>
            {navItems.map((item) =>
              (item.isVisible) && (
                <AdminBigMenu
                  key={item.path}
                  isHovered={isHovered}
                  data={item}
                />
              )
            )}
          </LnbMenuContainer>
        </LnbTopWrapper>
      </LnbSection>
      {!isHovered &&
        <>
          <LnbToggleArea
            aria-label="Open menu"
            onMouseEnter={openMenuWithHover}
            $isEditMode={false}
          />
          <HamburgerIconBtnWrapper
            aria-label="Open menu"
            onMouseEnter={openMenuWithHover}
          >
            <UniversalIconBtn
              isPrimary={false}
              size="fit"
              border={false}
              isTransparent={true}
              backgroundImg={hamburger128}
              onClick={() => setIsHovered(true)}
            />
          </HamburgerIconBtnWrapper>
        </>
      }
    </>
  )
}


const LnbMenuContainer = styled.div<{ $isActive: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  pointer-events: ${({ $isActive }) => $isActive ? 'auto' : 'none'};
  opacity: ${({ $isActive }) => $isActive ? 1 : 0};
  transition: opacity 0.4s ease;
`;

export default AdminLeftNavBar;
